/** PostgreSQL storage adapter — STUB. Implements StoragePort. */
export function createPostgresStorage() {
  const err = () => { throw new Error("POSTGRES_STORAGE_NOT_IMPLEMENTED"); };
  return {
    async listActors() { err(); }, async getActor() { err(); }, async saveActor() { err(); },
    async listSignals() { err(); }, async saveSignal() { err(); },
    async listOpportunities() { err(); }, async getOpportunity() { err(); },
    async saveOpportunity() { err(); }, async updateOpportunity() { err(); },
    async listPlays() { err(); }, async getLatestPlay() { err(); }, async savePlay() { err(); },
    async listOutcomes() { err(); }, async saveOutcome() { err(); },
    async listClosures() { err(); }, async saveClosure() { err(); },
    async listTeamMembers() { err(); }, async saveTeamMember() { err(); },
  };
}
